import { Const } from "../lib/const.cls";
import * as types from "@/types";
import * as RxFactory from "../../../../../store/api/rx-factory";
import * as Enpoints from "../../../../../store/api/endpoints";
import * as COMMON from "../../../../../store/commomFunction";
import moment from "moment";

export const actions = {
  //get withdrawal method list
  [Const.RUN_WITHDRAWAL_METHOD_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    let SelectedTypeValue = Object.values(credentials.globalParams)[0];
    _executeApi(
      Enpoints.EP_GET_WITHDARWA_METHOD_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          let filteredResult = [];
          filteredResult = result.res_data.filter(val => val.type == SelectedTypeValue);
		  if(SelectedTypeValue == '2'){
			commit(Const.SET_SKRILL_ID, filteredResult);
		  }else if(SelectedTypeValue == '3'){
			commit(Const.SET_NETELLER_ID, filteredResult);
		  }else if(SelectedTypeValue == '4'){
			commit(Const.SET_CRYPTO_ID_LIST, filteredResult);
		  }		

        } else {
          // commit(Const.SET_USER_COMMISSION, {})
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_TRADING_ACCOUNT_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TRADING_ACCOUNT_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_TRADING_ACCOUNT_LIST, result.res_data);
        } else {
          commit(Const.SET_TRADING_ACCOUNT_LIST, {});
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_USER_COMMISSION](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_USER_COMMISSION,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_USER_COMMISSION, result.res_data);
        } else {
          commit(Const.SET_USER_COMMISSION, {});
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_IB_TRADING_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_IB_TRADING_ACCOUNT_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_IB_TRADING_LIST, result.res_data);
        } else {
          commit(Const.SET_IB_TRADING_LIST, {});
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_TRADING_ACCOUNT_DETAIL](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TRADING_ACCOUNT_DETAIL,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          if (credentials.globalParams.platform != "ACT") {
            if (
              result.res_data.open_trades.csv_array &&
              result.res_data.open_trades.csv_array.length > 1
            ) {
              result.res_data.open_trades.csv_array.shift();
            } else {
              result.res_data.open_trades.csv_array = [];
            }

            if (
              result.res_data.history.csv_array &&
              result.res_data.history.csv_array.length > 1
            ) {
              result.res_data.history.csv_array.shift();
            } else {
              result.res_data.history.csv_array = [];
            }
          }
          commit(Const.SET_TRADING_ACCOUNT_DETAIL, result.res_data);
        } else {
          commit(Const.SET_TRADING_ACCOUNT_DETAIL, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  //=================================support==============================================================
  [Const.RUN_TICKET_RESEND_OTP](
    { commit, state, getters, dispatch },
    credentials
  ) {
    credentials.localParams.parameter.submitted = false;
    _executeApi(
      Enpoints.EP_TICKET_RESEND_OTP,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          _messageDisplayFunction(
            credentials.localParams.parameter.$parent,
            "suceessMsz18",
            "success"
          );
        } else {
          _messageDisplayFunction(
            credentials.localParams.parameter.$parent,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_TICKET_REQUEST_OTP](
    { commit, state, getters, dispatch },
    credentials
  ) {
    credentials.localParams.parameter.submitted = false;
    _executeApi(
      Enpoints.EP_TICKET_REQUEST_OTP,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          credentials.localParams.parameter.trans_id = result.res_data.trans_id;
          if (
            credentials.localParams.type &&
            credentials.localParams.type == "pro"
          ) {
            credentials.localParams.parameter.show_step = "";
          }
        } else {
          if (
            credentials.localParams.type &&
            credentials.localParams.type == "pro"
          ) {
            credentials.localParams.parameter.show_step = "";
          }
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_TICKET_CHECK_OTP](
    { commit, state, getters, dispatch },
    credentials
  ) {
    let localParam = credentials.localParams;
    localParam.parameter.submitted = false;
    localParam.parameter.$parent.submitted = false;
    _executeApi(
      Enpoints.EP_TICKET_CHECK_OTP,
      credentials,
      credentials.localParams.parameter.$parent,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          if (
            parseInt(localParam.module) == 1 &&
            parseInt(localParam.title) == 87
          ) {
            credentials.localParams.parameter.$parent.$parent.$parent.$parent.logout();
            //_messageDisplayFunction(credentials.localParams.parameter,'as you have changed your primary email , so please login again','success')
          } else if (
            parseInt(localParam.module) == 1 &&
            parseInt(localParam.title) == 88
          ) {
            let get_user = getters[types.GET_USER];
            get_user.mobile_no = localParam.data;
            commit(types.SET_STATE, get_user);

            var user = localStorage.getItem("user");
            user = atob(user);
            user = JSON.parse(user);
            user.mobile_no = credentials.localParams.data;
            localStorage.setItem("user", btoa(JSON.stringify(user)));
            localParam.parameter.$parent.congModule = true;
          } else if (
            credentials.localParams.data &&
            credentials.localParams.data == "pro"
          ) {
            credentials.localParams.parameter.$parent.show_step = "";
            localParam.parameter.$parent.congModule = true;
          } else if (parseInt(localParam.module) == 16) {
            //pehle 93 tha
            if (localParam.ticketRequestFrom == "deposit") {
              localParam.parameter.$router.replace({
                name: "fxView.deposit",
                params: { account_id_from_ticket: localParam.accountId },
              });
            } else if (localParam.ticketRequestFrom == "profile") {
              localParam.parameter.$router.replace("/profile");
              _messageDisplayFunction(
                credentials.localParams.parameter.$parent,
                "bank add successfully",
                "success"
              );
            } else if (localParam.ticketRequestFrom == "profileOtp") {
              credentials.localParams.parameter.$parent.trans_id = "";
              credentials.localParams.parameter.$parent.getUserProfileFunc();
              _messageDisplayFunction(
                credentials.localParams.parameter.$parent,
                "payment method disable successfully",
                "success"
              );
            } else {
              localParam.parameter.$parent.congModule = true;
            }
          } else {
            localParam.parameter.$parent.congModule = true;
          }
        } else {
          if (
            credentials.localParams.data &&
            credentials.localParams.data == "pro"
          ) {
            credentials.localParams.parameter.$parent.show_step = "";
          }
          _messageDisplayFunction(
            credentials.localParams.parameter.$parent,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_TICKET_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TICKET_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          if (
            credentials.localParams.parameter.$parent.setView != "" &&
            parseInt(credentials.globalParams.status) == 0
          ) {
            let ticket_id = "";
            for (let i = 0; i <= result.res_data.records.length - 1; i++) {
              if (parseInt(result.res_data.records[i].reason) == 121) {
                ticket_id = result.res_data.records[i].id;
              }
              if (i == result.res_data.records.length - 1) {
                credentials.localParams.parameter.$router.replace({
                  name: "fxView.view",
                  query: { id: ticket_id },
                });
              }
            }
          }
          commit(Const.SET_TICKET_LIST, result.res_data);
        } else {
          commit(Const.SET_TICKET_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_TICKET_REASON_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TICKET_REASON_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          let ticketData = _ticketFunction(result.res_data);
          commit(Const.SET_TICKET_DATA, ticketData);
          let count = 0;
          for (var key in result.res_data) {
            count++;
            if (
              result.res_data[key].categories &&
              result.res_data[key].categories != undefined &&
              result.res_data[key].categories.length > 0
            ) {
              let categoriesList = {};
              for (
                let i = 0;
                i <= result.res_data[key].categories.length - 1;
                i++
              ) {
                categoriesList[result.res_data[key].categories[i].id] =
                  result.res_data[key].categories[i];
                if (i == result.res_data[key].categories.length - 1) {
                  delete result.res_data[key].categories;
                  result.res_data[key]["categories"] = categoriesList;
                }
              }
            }
            if (count == Object.keys(result.res_data).length) {
              commit(Const.SET_TICKET_REASON_LIST, result.res_data);
            }
          }
        } else {
          commit(Const.SET_TICKET_REASON_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_TICKET_DETAIL](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TICKET_DETAIL,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_TICKET_VIEW, result.res_data);
        } else {
          commit(Const.SET_TICKET_VIEW, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_TICKET_REPLY]({ commit, state, getters, dispatch }, credentials) {
    _executeApi(
      Enpoints.EP_TICKET_REPLY,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          credentials.localParams.parameter.ticketDetail();
          credentials.localParams.parameter.document = "";
          credentials.localParams.parameter.$refs.file.value = "";
          credentials.localParams.parameter.text = "";
          let user_notify = getters[Const.GET_USER_NOTIFICATIONS];
          let i;
          if (user_notify.length > 0) {
            for (i = 0; i <= user_notify.length - 1; i++) {
              if (
                user_notify[i].notification_type == "TICKET" &&
                user_notify[i].ticket_id == credentials.localParams.tick_id
              ) {
                let user_info = getters[types.GET_USER];
                user_info.unread_notification =
                  user_info.unread_notification - 1;
                commit(types.SET_STATE, user_info);

                var user = localStorage.getItem("user");
                user = atob(user);
                user = JSON.parse(user);
                user.unread_notification = user.unread_notification - 1;
                localStorage.setItem("user", btoa(JSON.stringify(user)));
              }
            }
          }
          //_messageDisplayFunction(credentials.localParams.parameter,'message sent successfully','success')
        } else {
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  //=============================================
  [Const.RUN_GET_USER_PROFILE](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_USER_PROFILE,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        ////console.log(error, result)
        if (!error) {
          commit(Const.SET_USER_PROFILE, result.res_data[0]);
        } else {
        }
      }
    );
  },
  [Const.RUN_GET_COUNTRIES_LIST](
    { commit, state, dispatch, getters },
    credentials
  ) {
    //commit(Const.SET_COUNTRIES_LIST, getters[types.GET_COUNTRIES_FOR_IB])
    _executeApi(
      Enpoints.EP_GET_COUNTRIES_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_COUNTRIES_LIST, result.res_data);
        } else {
          commit(Const.SET_COUNTRIES_LIST, []);
        }
      }
    );
  },
  // [Const.RUN_GET_CITIES_LIST]({commit, state, dispatch,getters}, credentials){
  // 	_executeApi(Enpoints.EP_GET_CITIES_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
  // 		if(!error){
  // 			commit(Const.SET_CITIES_LIST, result.res_data)
  // 		}else{
  // 			commit(Const.SET_CITIES_LIST,[])
  // 		}
  // 	})
  //  	},
  [Const.RUN_API_DASHBOARD_DATA](
    { commit, state, dispatch, getters },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_API_DASHBOARD_DATA,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          result.res_data[0].dashboardData = JSON.parse(
            result.res_data[0].dashboardData
          );
          commit(Const.SET_DASHBOARD_DATA, result.res_data);
        } else {
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  [Const.RUN_GET_DASHBOARD_OTHER_DATA](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_DASHBOARD_OTHER_DATA,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          credentials.localParams.parameter.dashboardOtherData =
            result.res_data;
        } else {
          credentials.localParams.parameter.dashboardOtherData = {};
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_DASHBOARD_CHART_DATA](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_DASHBOARD_CHART_DATA,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_DASHBOARD_CHART_DATA, result.res_data);
          if (credentials.localParams.page === 'dashboard') {
            credentials.localParams.parameter.chartData("register");
          }
        } else {
          commit(Const.SET_DASHBOARD_CHART_DATA, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  [Const.RUN_GET_TOTAL_CLIENT](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TOTAL_CLIENT,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          credentials.localParams.parameter.totalclient = result.res_data;
        } else {
          credentials.localParams.parameter.totalclient = {};
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  [Const.RUN_GET_TOTAL_SUBIB](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TOTAL_SUBIB,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          credentials.localParams.parameter.totalSubIB = result.res_data;
        } else {
          credentials.localParams.parameter.totalSubIB = {};
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  // user sub ib list
  [Const.RUN_GET_USER_SUBIB_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_USER_SUBIB_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_USER_SUBIB_LIST, result.res_data);
        } else {
          commit(Const.SET_USER_SUBIB_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  //====================================admin=================================================
  [Const.RUN_GET_IB_LIST]({ commit, state, getters, dispatch }, credentials) {
    _executeApi(
      Enpoints.EP_GET_IB_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          if (result.res_data.totalRecords > 0) {
            for (let i = 0; i <= result.res_data.records.length - 1; i++) {
              result.res_data.records[i].role_array =
                result.res_data.records[i].roles.split(",");
              if (i == result.res_data.records.length - 1) {
                commit(Const.SET_IB_LIST, result.res_data);
              }
            }
          } else {
            commit(Const.SET_IB_LIST, result.res_data);
          }
        } else {
          commit(Const.SET_IB_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_IB_DETAIL]({ commit, state, getters, dispatch }, credentials) {
    _executeApi(
      Enpoints.EP_GET_IB_DETAIL,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_IB_DETAIL, result.res_data[0]);
        } else {
          commit(Const.SET_IB_DETAIL, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  //====================================client=================================================
  /*[Const.RUN_WITHDRAWAL_METHODS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_WITHDRAWAL_METHODS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, result.res_data)
			}else{
				commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
		},*/

  //list and detail
  [Const.RUN_USER_COUNT]({ commit, state, getters, dispatch }, credentials) {
    _executeApi(
      Enpoints.EP_USER_COUNT,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_USER_COUNT, result.res_data);
        } else {
          commit(Const.SET_USER_COUNT, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_USER_LIST]({ commit, state, getters, dispatch }, credentials) {
    _executeApi(
      Enpoints.EP_GET_USER_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          if (credentials.localParams.page == "search") {
            credentials.localParams.parameter.searchData = result.res_data;
          } else {
            commit(Const.SET_USER_LIST, result.res_data);
          }
        } else {
          if (credentials.localParams.page == "search") {
            credentials.localParams.parameter.searchData = [];
            _messageDisplayFunction(
              credentials.localParams.parameter,
              result.res_data,
              "error"
            );
          } else {
            commit(Const.SET_USER_LIST, []);
            _messageDisplayFunction(
              credentials.localParams.parameter,
              result.res_data,
              "error"
            );
          }
        }
      }
    );
  },

  [Const.RUN_GET_USER_VIEW]({ commit, state, getters, dispatch }, credentials) {
    _executeApi(
      Enpoints.EP_GET_USER_VIEW,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_USER_VIEW, result.res_data[0]);
          if (
            credentials.localParams.page &&
            credentials.localParams.page == "createPdf"
          ) {
            credentials.localParams.parameter.$router.push({
              path: "/clientpdf",
              query: { id: credentials.globalParams.user_id },
            });
          } else {
            credentials.localParams.parameter.$router.push({
              path: "/view",
              query: { id: credentials.globalParams.user_id },
            });
          }
        } else {
          commit(Const.SET_USER_VIEW, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  //====================================deposit================================================

  [Const.RUN_GET_DEPOSIT_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_DEPOSIT_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_DEPOSIT_LIST, result.res_data);
        } else {
          commit(Const.SET_DEPOSIT_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_DEPOSIT_VIEW](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_DEPOSIT_VIEW,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_DEPOSIT_VIEW, result.res_data[0]);
          //credentials.localParams.parameter.$router.push({path: '/deposit-view',query: { "id" : credentials.globalParams.user_id } })
        } else {
          commit(Const.SET_DEPOSIT_VIEW, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  //====================================withdrawal=============================================
  [Const.RUN_GET_ACCOUNT_DETAIL](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_ACCOUNT_DETAIL,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          credentials.localParams.parameter.balance = result.res_data.balance;
        } else {
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_WITHDRAWAL_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_WITHDRAWAL_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_WITHDRAWAL_LIST, result.res_data);
        } else {
          commit(Const.SET_WITHDRAWAL_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_COMMISSION_REQUEST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_COMMISSION_REQUEST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
        } else {
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_WITHDRAWAL_COMMISSION_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_WITHDRAWAL_COMMISSION_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_WITHDRAWAL_COMMISSION_LIST, result.res_data);
        } else {
          commit(Const.SET_WITHDRAWAL_COMMISSION_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  [Const.RUN_GET_AFFILIATE_EARNINGS](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_AFFILIATE_EARNINGS,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_AFFILIATE_EARNINGS, result.res_data);
        } else {
          commit(Const.SET_AFFILIATE_EARNINGS, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  [Const.RUN_GET_WITHDRAWAL_VIEW](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_WITHDRAWAL_VIEW,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_WITHDRAWAL_VIEW, result.res_data[0]);
          //credentials.localParams.parameter.$router.push({ path: '/withdrawal-view', query: { "id" : credentials.globalParams.user_id } })
        } else {
          commit(Const.SET_WITHDRAWAL_VIEW, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  [Const.RUN_GET_WITHDRAWAL_DESC](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_WITHDRAWAL_DESC,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          credentials.localParams.parameter.free_margin =
            result.res_data.margin_detail.freeMargin;
          let currencyIcon = {
            EUR: "€",
            USD: "$",
            GBP: "£",
            CHF: "CHF",
            JPY: "¥",
            AUD: "$",
          };
          credentials.localParams.parameter.free_margin_currency =
            result.res_data.margin_detail.freeMargin +
            " " +
            currencyIcon[credentials.localParams.parameter.currencyData];
          if (Object.keys(result.res_data.allowedWithdrawal).length > 0) {
            credentials.localParams.parameter.allowedWithdrawal =
              result.res_data.allowedWithdrawal;
          } else {
            let json = {},
              count = 0;
            let get_withdrawal_method =
              getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP];
            for (var key in get_withdrawal_method) {
              count++;

              json[key] = {};
              let count1 = 0;
              for (var innerkey in get_withdrawal_method[key]) {
                count1++;
                json[key][innerkey] = {};
                json[key][innerkey][
                  credentials.localParams.parameter.currencyData
                ] = result.res_data.margin_detail.freeMargin;

                if (parseInt(key) != 5) {
                  json[key][innerkey]["allowed"] = "1";
                }
              }

              if (count == Object.keys(get_withdrawal_method).length) {
                ////console.log("=======I m IN IF Callback====>")
                credentials.localParams.parameter.allowedWithdrawal = json;
                credentials.localParams.parameter.showBalPanel = false;
              }
            }
          }

          credentials.localParams.parameter.pay_option = "";
          credentials.localParams.parameter.amount = "";
          credentials.localParams.parameter.avalBalance = "";
          credentials.localParams.parameter.account_number = "";
          credentials.localParams.parameter.submitted = false;
        } else {
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },

  [Const.RUN_GET_USER_REGISTERATION_STEP_DATA](
    { commit, state, dispatch, getters },
    credentials
  ) {
    //console.log("chkkkkk nowww")
    let user_info = getters[types.GET_USER];
    const _that = credentials.localParams.parameter;
    if (parseInt(user_info.step) >= 2) {
      _that.disable = true;
    }
    if (
      parseInt(credentials.localParams.step) <= parseInt(user_info.step) ||
      parseInt(credentials.localParams.step) == parseInt(user_info.step) + 1
    ) {
    } else {
      let stepData =
        parseInt(user_info.step) == 0 ? "/step1" : "/step" + user_info.step;
      _that.$router.replace(stepData);
    }
    _executeApi(
      Enpoints.EP_GET_USER_REGISTERATION_STEP_DATA,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        //console.log("RUN_GET_USER_REGISTERATION_STEP_DATA",error, result)
        if (!error) {
          switch (parseInt(credentials.localParams.step)) {
            case 1:
              let dob = moment(result.res_data[0].profile.dob).format(
                "YYYY-MM-DD"
              );
              dob = new Date(dob);
              _that.ind_f_name = result.res_data[0].profile.firstname;
              _that.ind_l_name = result.res_data[0].profile.lastname;
              _that.ind_dob = moment(new Date(dob)).format("YYYY-MM-DD");

              //adress-detail
              _that.ind_city = result.res_data[0].profile.city;
              _that.ind_post_code = result.res_data[0].profile.post_code;
              _that.address1 = result.res_data[0].profile.address1;
              _that.address2 = result.res_data[0].profile.address2;
              _that.ind_residence_country =
                result.res_data[0].profile.residence_country;

              //session
              _that.mobile_number = result.res_data[0].mobile_no;

              _that.countryFunc();
              break;
            case 2:
              if (parseInt(result.res_data[0].profile.terms_agreed) == 1) {
                _that.check1 = true;
                _that.check2 = true;
                _that.check3 = true;
                _that.check4 = true;
              }
              break;
            case 3:
              if (result.res_data[0].documents.length > 0) {
                for (
                  let i = 0;
                  i <= result.res_data[0].documents.length - 1;
                  i++
                ) {
                  if (
                    _that.documentJsonData[
                      result.res_data[0].documents[i].document_type
                        .split(" ")
                        .join("_")
                    ] == undefined
                  ) {
                    _that.documentJsonData[
                      result.res_data[0].documents[i].document_type
                        .split(" ")
                        .join("_")
                    ] = [];
                  }
                  result.res_data[0].documents[i].name =
                    result.res_data[0].documents[i].document;
                  _that.documentJsonData[
                    result.res_data[0].documents[i].document_type
                      .split(" ")
                      .join("_")
                  ].push(result.res_data[0].documents[i]);
                }
              } else {
                // _that.documentJsonSitutaion = { 'identity_document': 'upload', 'residence_document': 'upload', 'ipv_document': 'upload' }
              }

              _that.idnumber = result.res_data[0].profile.P_IDNUMBER;

              if (
                parseInt(result.res_data[0].profile.APPROVED_TO_PROCEED) == 1
              ) {
                _that.acceptCountryFlag = 1;
              } else {
                _that.acceptCountryFlag = 2;
              }
              break;
          }
        }
      }
    );
  },

  [Const.RUN_WITHDRAWAL_REQUEST_OTP]( { commit, state, getters, dispatch }, credentials ) {
    _executeApi(
      Enpoints.EP_WITHDRAWAL_REQUEST_OTP,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          let user_json = getters["GET_USER"];
          credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
        } else {
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_WITHDRAWAL_CHECK_OTP](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_WITHDRAWAL_EMAIL_LINK,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          if (credentials.localParams.params) {
            credentials.localParams.parameter.success = true;
          } else {
            credentials.localParams.parameter.transaction_id = "";
            credentials.localParams.parameter.congModuleWithdrawal = true;
          }
        } else {
          if (credentials.localParams.params) {
            credentials.localParams.parameter.success = false;
            credentials.localParams.parameter.msg = result.res_data;
          } else {
            _messageDisplayFunction(
              credentials.localParams.parameter,
              result.res_data,
              "error"
            );
          }
        }
      }
    );
  },
  [Const.RUN_RESEND_EMAIL_LINK](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_RESEND_EMAIL_LINK,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          _messageDisplayFunction(
            credentials.localParams.parameter,
            "suceessMsz16",
            "success"
          );
        } else {
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_WITHDRAWAL_METHODS](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_WITHDRAWAL_METHODS,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          //withdrawalMethodResponse
          commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, result.res_data);
          let json = {},
            count = 0;
          for (var key in result.res_data) {
            count++;
            json[key] = {};
            let count1 = 0;
            for (var innerkey in result.res_data[key]) {
              count1++;
              json[key][result.res_data[key][innerkey].id] =
                result.res_data[key][innerkey];
              if (count1 == Object.keys(result.res_data[key]).length) {
                ////console.log(json)
              }
            }
            if (count == Object.keys(result.res_data).length) {
              commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP, json);
            }
          }
        } else {
          commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP, []);
          commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  //====================================bonus=============================================
  [Const.RUN_GET_BONUS_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_BONUS_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_BONUS_LIST, result.res_data);
        } else {
          commit(Const.SET_BONUS_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_BONUS_VIEW](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_BONUS_VIEW,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_BONUS_VIEW, result.res_data[0]);
          //credentials.localParams.parameter.$router.push({ path: '/bonus-view', query: { "id" : credentials.globalParams.user_id } })
        } else {
          commit(Const.SET_BONUS_VIEW, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  //====================================trading================================================

  [Const.RUN_GET_TRADING_LIST](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TRADING_LIST,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_TRADING_LIST, result.res_data);
        } else {
          commit(Const.SET_TRADING_LIST, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
  [Const.RUN_GET_TRADING_VIEW](
    { commit, state, getters, dispatch },
    credentials
  ) {
    _executeApi(
      Enpoints.EP_GET_TRADING_VIEW,
      credentials,
      credentials.localParams.parameter,
      { Authorization: "Bearer " + getters.GET_TOKEN },
      commit,
      (error, result) => {
        if (!error) {
          commit(Const.SET_TRADING_VIEW, result.res_data[0]);
          credentials.localParams.parameter.accountDetail();
          //credentials.localParams.parameter.$router.push({ path: '/trading-view', query: { "id" : credentials.globalParams.id } })
        } else {
          commit(Const.SET_TRADING_VIEW, []);
          _messageDisplayFunction(
            credentials.localParams.parameter,
            result.res_data,
            "error"
          );
        }
      }
    );
  },
};

//------------------------------------------------------Functions------------------------------------------------------
function _cleanUp(commit, msg, status, loaderId) {
  let loaderArr = typeof loaderId !== "undefined" ? [loaderId] : [];
  commit("SET_INFO", msg);
}
function _ticketFunction(respData) {
  // priority basis keys
  //parent  ['1', '3', '4', '2']
  const getResponseData = respData;
  let keyByPriortity = [];
  let obj = {};
  let count = 0;
  for (var key in getResponseData) {
    const parent_id = getResponseData[key].id;
    keyByPriortity[getResponseData[key].priority] = parent_id;
    obj["-1"] = keyByPriortity;

    let childCount = 0;
    count++;
    const child = getResponseData[key].categories;
    ////console.log(child)
    if (child) {
      let childPriority = [];
      for (var i = 0; i <= child.length - 1; i++) {
        const children = child[i];
        childPriority[children.priority] = children.id;
        childCount++;
        if (i == child.length - 1) {
          //empty
          var filtered = childPriority.filter(function (el) {
            return el != null && el != "";
          });
          obj[parent_id] = filtered;
        }
        if (
          i == child.length - 1 &&
          count == Object.keys(getResponseData).length
        ) {
          var childfiltered = keyByPriortity.filter(function (el) {
            return el != null && el != "";
          });
          obj["-1"] = childfiltered;
          return obj;
        }
      }
    } else {
      if (count == Object.keys(getResponseData).length) {
        var childfiltered = keyByPriortity.filter(function (el) {
          return el != null && el != "";
        });
        obj["-1"] = childfiltered;
        return obj;
      }
    }
  }

  //return keyByPriortity
}
function _handleErrorResponse(e, commit) {
  let response = { info: "NOK", msg: "Service not available" };
  if (typeof e.response === "undefined") {
    try {
      const statusCheck = e.toString().toLowerCase();
      if (statusCheck.indexOf("network") > -1) {
        response = { info: "NOK", msg: "Network Error" };
      }
    } catch (e) {}
  } else {
    response = e.response.data;
  }
  _cleanUp(commit, response, response.status);
  if (typeof e.response !== "undefined") {
    if (e.response.status == 401) {
      let data = {};
      let options = {};
      options.forward = true;
      _handleLogout(data, commit, options);
    }
  }
}
function _handleLogout(data, commit, options) {
  let user = {};
  const state = [];
  window.sessionStorage.setItem("user_info", "");
  if ("msg" in data && "info" in data) {
    _cleanUp(commit, data.msg, data.info);
  }
  if (options.forward === true) {
    window.location.replace("/");
  }
}
function _executeApi(
  apiLink,
  credentials,
  getLoaderParams,
  getToken,
  commit,
  callback
) {
  try {
    let response_array = [];
    if (credentials.localParams.module == "ticket-reply") {
      credentials.globalParams = credentials.globalParams.form;
    }
    getLoaderParams.pageLoader = true;

    RxFactory.post(
      Enpoints.BASE_URL + apiLink,
      credentials.globalParams,
      getToken
    )
      .map((response) => response.data)
      .subscribe(
        (data) => {
          getLoaderParams.pageLoader = false;
          if ("info" in data) {
            if (data.info === "OK") {
              response_array.res_data = data.data;
              callback(false, response_array);
            } else {
              if (typeof data.msg == "object") {
                response_array.res_data = data.msg.msg;
              } else {
                response_array.res_data = data.msg;
              }
              callback(true, response_array);
            }
          }
        },
        (e) => {
          _handleErrorResponse(e, commit);
        }
      );
  } catch (ex) {
    _handleErrorResponse(ex, commit);
  }
}
function _messageDisplayFunction(getParameter, getMessage, msgType) {
  // getParameter.$notify({
  // 	group: 'foo',
  // 	type : msgType,
  // 	text: getMessage,
  // 	duration: 10000,
  // 	closeOnClick : true
  // });
  getParameter.response_msg = getMessage;
  getParameter.msg_type = msgType;
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/actions.js